var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subpage-nav"},[_c('container',[_c('div',{staticClass:"subpage-nav__list"},[_c('div',{staticClass:"subpage-nav__item"},[_c('p',{staticClass:"subpage-nav__link",attrs:{"exact":""}},[_c('span',{staticClass:"btn-txt"},[_vm._v("\n            "+_vm._s(_vm.links.title)+"\n          ")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }